var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIoniconaalertcircleoutline1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 12C21 7.03125 16.9687 3 12 3C7.03125 3 3 7.03125 3 12C3 16.9687 7.03125 21 12 21C16.9687 21 21 16.9687 21 12Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7307 7.78407L11.9998 13.5005L12.2684 7.78407C12.2701 7.74753 12.2642 7.71103 12.2513 7.67681C12.2384 7.64258 12.2186 7.61136 12.1932 7.58503C12.1678 7.55871 12.1373 7.53784 12.1036 7.52371C12.0698 7.50957 12.0336 7.50246 11.997 7.50282V7.50282C11.9608 7.50316 11.9251 7.51078 11.892 7.52523C11.8589 7.53967 11.829 7.56065 11.8041 7.5869C11.7793 7.61315 11.76 7.64414 11.7474 7.67801C11.7348 7.71189 11.7291 7.74796 11.7307 7.78407V7.78407Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 17.2456C11.8146 17.2456 11.6333 17.1906 11.4792 17.0876C11.325 16.9846 11.2048 16.8382 11.1339 16.6669C11.0629 16.4956 11.0443 16.3071 11.0805 16.1252C11.1167 15.9434 11.206 15.7763 11.3371 15.6452C11.4682 15.5141 11.6352 15.4248 11.8171 15.3886C11.999 15.3524 12.1875 15.371 12.3588 15.442C12.5301 15.5129 12.6765 15.6331 12.7795 15.7873C12.8825 15.9414 12.9375 16.1227 12.9375 16.3081C12.9375 16.5567 12.8387 16.7952 12.6629 16.971C12.4871 17.1468 12.2486 17.2456 12 17.2456Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIoniconaalertcircleoutline1);
export default __webpack_public_path__ + "static/media/ioniconaalertcircleoutline-1.c40977aa0882479b3f1cf5a70993ef16.svg";
export { ForwardRef as ReactComponent };